"use strict";

exports.__esModule = true;
exports.ToolBoxSelector = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _Core = require("../../Core");
var _helper = require("../../Widgets/MeasureChart/helper");
var _constants = require("../constants");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var ToolBoxSelector = exports.ToolBoxSelector = function ToolBoxSelector(props) {
  var _toolbox$magicType, _toolbox$magicType2, _toolbox$dataView, _toolbox$saveAsImage, _toolbox$downloadData;
  var _useContext = (0, _react.useContext)(_Core.TranslatorContext),
    translate = _useContext.translate;
  var elementEditor = props.elementEditor,
    path = props.path,
    toolbox = props.toolbox;
  var defaultOrientation = _constants.ORIENTATION_VERTICAL;
  (0, _react.useEffect)(function () {
    if (!toolbox || Object.entries(toolbox).length === 0) {
      elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.toolbox",
          value: el.props.toolbox = {
            show: false,
            orientation: defaultOrientation,
            magicType: {
              types: []
            },
            dataView: {
              show: false
            },
            saveAsImage: {
              show: false
            },
            downloadData: {
              show: false
            }
          }
        };
      });
    }
  }, [toolbox, elementEditor, path]);
  return /*#__PURE__*/_react["default"].createElement(_helper.Well, {
    "data-testid": "ToolBoxSelector"
  }, /*#__PURE__*/_react["default"].createElement(_helper.WellTitle, null, translate("ToolBoxSelector.toolBoxOptions.label", "Tool box options")), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("ToolBoxSelector.toolBoxPosition.label", "Tool box position")
  }, /*#__PURE__*/_react["default"].createElement(_Core.Selector, {
    dataTestId: "ToolBoxSelector.toolBoxPosition.selector",
    items: [_constants.ORIENTATION_VERTICAL, _constants.ORIENTATION_HORIZONTAL],
    selected: (toolbox == null ? void 0 : toolbox.orientation) != null ? [toolbox.orientation] : [defaultOrientation],
    getKey: function getKey(name) {
      return name;
    },
    renderItemText: function renderItemText(name) {
      return name;
    },
    onSelect: function onSelect(_ref) {
      var selected = _ref[0];
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.toolbox.orientation",
          value: el.props.toolbox.orientation = selected
        };
      });
    }
  })), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("ToolBoxSelector.toolBoxMaticType.label", "Magic types (works only for line and bar charts)")
  }, /*#__PURE__*/_react["default"].createElement(_Core.Selector, {
    dataTestId: "ToolBoxSelector.toolBoxMaticType.selector",
    items: [_constants.CHART_LINE, _constants.CHART_BAR, _constants.CHART_STACK],
    selected: (toolbox == null || (_toolbox$magicType = toolbox.magicType) == null || (_toolbox$magicType = _toolbox$magicType.types) == null ? void 0 : _toolbox$magicType.length) > 0 ? toolbox.magicType.types : [],
    getKey: function getKey(name) {
      return name;
    },
    renderItemText: function renderItemText(name) {
      return name;
    },
    multiple: true,
    onSelect: function onSelect(selected) {
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.toolbox.magicType.types",
          value: el.props.toolbox.magicType.types = selected
        };
      });
    }
  })), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    label: translate("ToolBoxSelector.toolBoxShow.switch", "Show toolbox"),
    "data-testid": "ToolBoxSelector.toolBoxShow.switch",
    checked: toolbox == null ? void 0 : toolbox.show,
    onChange: function onChange(e) {
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.toolbox.show",
          value: el.props.toolbox.show = e.target.checked
        };
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    label: translate("ToolBoxSelector.toolBoxMagicType.switch", "Show magic type"),
    "data-testid": "ToolBoxSelector.toolBoxMagicType.switch",
    checked: toolbox == null || (_toolbox$magicType2 = toolbox.magicType) == null ? void 0 : _toolbox$magicType2.show,
    onChange: function onChange(e) {
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.toolbox.magicType.show",
          value: el.props.toolbox.magicType.show = e.target.checked
        };
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    label: translate("ToolBoxSelector.toolBoxDataView.switch", "Show data view"),
    "data-testid": "ToolBoxSelector.toolBoxDataView.switch",
    checked: toolbox == null || (_toolbox$dataView = toolbox.dataView) == null ? void 0 : _toolbox$dataView.show,
    onChange: function onChange(e) {
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.toolbox.dataView.show",
          value: el.props.toolbox.dataView.show = e.target.checked
        };
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    label: translate("ToolBoxSelector.toolBoxDownloadImage.switch", "Show download image"),
    "data-testid": "ToolBoxSelector.toolBoxDownloadImage.switch",
    checked: toolbox == null || (_toolbox$saveAsImage = toolbox.saveAsImage) == null ? void 0 : _toolbox$saveAsImage.show,
    onChange: function onChange(e) {
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.toolbox.saveAsImage.show",
          value: el.props.toolbox.saveAsImage.show = e.target.checked
        };
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    label: translate("ToolBoxSelector.toolBoxDownloadData.switch", "Show download data"),
    "data-testid": "ToolBoxSelector.toolBoxDownloadData.switch",
    checked: toolbox == null || (_toolbox$downloadData = toolbox.downloadData) == null ? void 0 : _toolbox$downloadData.show,
    onChange: function onChange(e) {
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.toolbox.downloadData.show",
          value: el.props.toolbox.downloadData.show = e.target.checked
        };
      });
    }
  }));
};